/**
 * Desmos GraphingCalculator 动态加载器（CDN，单例）。
 * 首次调用注入官方 calculator.js（SAT 官方所用）；返回全局 Desmos 对象。
 *
 * apiKey：优先用 VITE_DESMOS_API_KEY（生产请申请自有 key 绑定域名），
 * 否则回退到 Desmos 官方 demo key（仅开发/测试用，勿用于生产）。
 */
const DESMOS_API_KEY =
  (import.meta.env.VITE_DESMOS_API_KEY as string) || 'dcb31709b452b1cf9dc26972add0fda6';
const DESMOS_VERSION = 'v1.10';

let loadPromise: Promise<any> | null = null;

declare global {
  interface Window {
    Desmos?: any;
  }
}

/** 确保 Desmos 已加载（幂等）；resolve 全局 Desmos 对象 */
export function ensureDesmos(): Promise<any> {
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    if (window.Desmos) {
      resolve(window.Desmos);
      return;
    }
    const lang = navigator.language?.startsWith('zh') ? 'zh-CN' : 'en';
    const script = document.createElement('script');
    script.src = `https://www.desmos.com/api/${DESMOS_VERSION}/calculator.js?apiKey=${DESMOS_API_KEY}&lang=${lang}`;
    script.async = true;
    script.onload = () => {
      if (window.Desmos) resolve(window.Desmos);
      else reject(new Error('Desmos loaded but global missing'));
    };
    script.onerror = () => reject(new Error('Failed to load Desmos calculator.js'));
    document.head.appendChild(script);
  });

  return loadPromise;
}
